export class CartItem {
  receivingCondition: number;
  paymentReceiptForm: number;
  productCode: number;
  productClasCode: number;
  quantity: number;
  measurementUnitQuantity: number;
  measurementUnitDescription: string;
  measurementUnit: string;
  price: number;
  value: number;
  operation: string; // +, - or =
  idCart: number;
}
